import React, {useEffect, useState} from "react";
import axios from "axios";
import {API_BASE_URL} from "../../config";
import Button from "../Elements/Button";
import {toast} from "react-toastify";

const toNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
};

const parseIdsFromString = (s) =>
    String(s || "")
        .trim()
        .split(",")
        .map((x) => toNum(x))
        .filter((n) => n !== null);

const UserData = ({user: userId}) => {
    const [user, setUser] = useState({username: "", firstname: "", lastname: "", id: null});
    const [departments, setDepartments] = useState([]);            // [{value:number,label:string}]
    const [roles, setRoles] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState([]);                   // number[]
    const [selectedRole, setSelectedRole] = useState(null);                 // number | null

    useEffect(() => {
        if (!userId) return;

        // 1) Infos utilisateur
        axios
            .post(`${API_BASE_URL}/get_user_infos_by_id`, {user: userId})
            .then((res) => {
                console.log(res)
                const data = res.data?.[0];
                if (!data) return;
                setUser({
                    username: data.username || "",
                    firstname: data.firstname || "",
                    lastname: data.lastname || "",
                    id: data.id ?? null,
                });
                setSelectedRole(toNum(data.role_id));
                setSelectedDepartment(parseIdsFromString(data.departement_id));
            })
            .catch(() => toast.error("Impossible de charger l'utilisateur"));

        // 2) Liste des départements
        axios
            .post(`${API_BASE_URL}/get_all_departments`)
            .then((response) => {
                const list = (response.data || []).map((d) => ({
                    value: toNum(d.id),
                    label: d.name,
                })).filter((d) => d.value !== null);
                setDepartments(list);
            })
            .catch(() => toast.error("Impossible de charger les départements"));
        // 2) Liste des départements
        axios
            .post(`${API_BASE_URL}/get_all_roles`)
            .then((response) => {
                console.log(response)
                const list = (response.data || []).map((d) => ({
                    value: toNum(d.id),
                    label: d.name,
                })).filter((d) => d.value !== null);
                setRoles(list);
            })
            .catch(() => toast.error("Impossible de charger les départements"));
    }, [userId]);

    const handleChange = (key, value) => setUser((prev) => ({...prev, [key]: value}));

    const toggleDepartment = (deptId) => {
        setSelectedDepartment((prev) =>
            prev.includes(deptId) ? prev.filter((id) => id !== deptId) : [...prev, deptId]
        );
    };
    const selectRole = (roleId) => setSelectedRole(roleId);

    const handleSave = () => {
        if (!user.id) return toast.error("Utilisateur invalide");
        axios
            .post(`${API_BASE_URL}/update_user_data`, {
                id: user.id,
                firstname: user.firstname,
                lastname: user.lastname,
                departments: selectedDepartment.join(","), // ← envoie "1,5,9"
                role: selectedRole,
            })
            .then(() => toast.success("Utilisateur enregistré"))
            .catch(() => toast.error("Erreur lors de l'enregistrement"));
    };

    return (
        <div className="display-flex flex-direction-column gap-20">
            {/* Actions */}
            <Button
                iconBackground="bg-fifth"
                onClick={handleSave}
                icon="fa-floppy-disk"
                label="Enregistrer"
                textClassNames="bg-third btn-save"
                iconClasseNames="color-white"
                disableLink
            />

            {/* Identifiants */}
            <div className="container display-flex justify-content-space-between p-20 bg-white flex-direction-column">
                <div className="display-flex gap-20">
                    <div className="flex text-left mb-20 display-flex flex-direction-column gap-10">
                        <strong className="text-left color-third">Nom d'utilisateur</strong>
                        <input
                            disabled
                            type="text"
                            value={user.username}
                            className="input p-10 cursor-disabled"
                        />
                    </div>
                </div>
            </div>

            {/* Infos personnelles + Départements */}
            <div className="container display-flex justify-content-space-between p-20 bg-white flex-direction-column">
                <div className="display-flex gap-20 align-items-flex-start">
                    <div className="flex text-left mb-20 display-flex flex-direction-column gap-10">
                        <strong className="text-left color-third">Prénom</strong>
                        <input
                            type="text"
                            value={user.firstname}
                            onChange={(e) => handleChange("firstname", e.target.value)}
                            className="input p-10"
                        />
                    </div>

                    <div className="flex text-left mb-20 display-flex flex-direction-column gap-10">
                        <strong className="text-left color-third">Nom de famille</strong>
                        <input
                            type="text"
                            value={user.lastname}
                            onChange={(e) => handleChange("lastname", e.target.value)}
                            className="input p-10"
                        />
                    </div>


                </div>
            </div>
            <div className="container display-flex justify-content-space-between p-20 bg-white">

                <div className="flex text-left mb-20 display-flex flex-direction-column gap-10">
                    <strong className="text-left color-third">Départements</strong>
                    <div className="option-group display-flex flex-direction-column gap-10">
                        {departments.map((dpt) => (
                            <label key={dpt.value} className="display-flex align-items-center">
                                <input
                                    className="mr-10"
                                    type="checkbox"
                                    name="departments"
                                    value={dpt.value}
                                    checked={selectedDepartment.includes(dpt.value)}
                                    onChange={() => toggleDepartment(dpt.value)}
                                />
                                {dpt.label}
                            </label>
                        ))}
                    </div>
                </div>

                <div className="flex text-left mb-20 display-flex flex-direction-column gap-10">
                    <strong className="text-left color-third">Rôle</strong>
                    <div className="option-group display-flex flex-direction-column gap-10">
                        {roles.map((role) => (
                            <label key={role.value} className="display-flex align-items-center">
                                <input
                                    className="mr-10"
                                    type="radio"
                                    name="role"
                                    value={role.value}
                                    checked={Number(selectedRole) === role.value}
                                    onChange={() => selectRole(role.value)}
                                />
                                {role.label}
                            </label>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserData;
